{
  "infoCard": {
    "labels": {
      "aircraft": "Aeronave",
      "utilization": "Utilización",
      "trips": "Viajes",
      "doorSize": "Puerta",
      "estTowTime": "Remolq. est.",
      "estValue": "Valor est.",
      "total": "Total",
      "transients": "Transients",
      "dimensions": "Dimensiones",
      "parameters": "Parámetros"
    },
    "tooltips": {
      "aircraftCount": "# aeronaves en hangar / # aeronaves deseadas",
      "utilization": "Util. de aeronaves apiladas / Util. de todas las aeronaves en pantalla. Puedes ajustar cómo se calcula la utilización en Configuración > Configuración.",
      "towTime": "Tiempo estimado para remolcar todas las aeronaves fuera del hangar.",
      "tripsCount": "Viajes activos / Viajes futuros asignados a este hangar",
      "estimatedValue": "Valor estimado de tu hangar. Incluye todos los inquilinos base y cualquier tránsito que puedas acomodar en el hangar.",
      "transientValue": "Revenue from overnight transient aircraft."
    },
    "units": {
      "perDay": " / día",
      "perMonth": " / mes"
    }
  },
  "customStackDialog": {
    "title": "Personaliza tu Stack",
    "buttons": {
      "back": "Volver",
      "runStack": "Ejecutar"
    },
    "sections": {
      "spacingSOP": "Espaciado SOP",
      "preferences": "Preferencias"
    },
    "labels": {
      "horizontal": "Horizontal (ft)",
      "vertical": "Vertical (ft)",
      "leftWall": "Pared izquierda (ft)",
      "backWall": "Pared trasera (ft)",
      "rightWall": "Pared derecha (ft)",
      "towingEquipment": "Equipo de remolque para stack",
      "ignore": "¿Ignorar?",
      "allowOverlap": "Permitir traslape",
      "ignoreNoseInOut": "Ignorar preferencias de orientación de nariz",
      "ignoreFrontBack": "Ignorar preferencias de frente/fondo",
      "ignoreOutsideHangar": "Ignorar preferencias de permitir fuera del hangar",
      "cloudPrioritization": "Usar priorización de posición en nube",
      "sampleSize": "Tamaño muestra",
      "cornerStrategy": "Estrategia de esquina",
      "xyWeights": "Pesos XY",
      "xWeight": "X",
      "yWeight": "Y",
      "densityThreshold": "Umbral de densidad 3D"
    },
    "tooltips": {
      "spacingSOP": "Anular SOPs. Por defecto se usarán los SOPs configurados para tu FBO.",
      "preferences": "Personaliza tus preferencias de apilamiento. Se aplicarán a todas las aeronaves."
    },
    "descriptions": {
      "allowOverlap": "Permitir que el algoritmo superponga aviones.",
      "ignoreNoseInOut": "Permitir que el algoritmo use tus preferencias de orientación de remolque.",
      "ignoreFrontBack": "Permitir que el algoritmo use tu preferencia de fila delantera o trasera.",
      "ignoreOutsideHangar": "Permitir que el algoritmo considere tus preferencias de \"se puede omitir\".",
      "cloudPrioritization": "Usa priorización de posición \"Cloud\" (ConvexHull) para determinar qué posiciones evaluar."
    }
  },
  "evaluatingStackDialog": {
    "titles": {
      "selectStack": "Seleccionar un Stack",
      "evaluating": "Evaluando Stack"
    },
    "progress": {
      "preparing": "Preparando despegue...",
      "scenariosEvaluated": "{{formattedCount}} escenarios evaluados"
    },
    "complete": {
      "modifyLink": "Intenta modificar tus requisitos.",
      "finishedMessage": "Mensaje finalizado"
    },
    "buttons": {
      "cancel": "Cancelar Stack",
      "endEarly": "Finalizar apilamiento"
    }
  },
  "runStack": {
    "buttons": {
      "autoStack": "AutoStack",
      "autoStackDev": "AutoStack Dev",
      "results": "Resultados",
      "cancel": "Cancelar",
      "customizeStack": "Personalizar Stack",
      "runStack": "Ejecutar"
    },
    "tooltips": {
      "autoStack": "AutoStack",
      "results": "Resultados"
    },
    "dialog": {
      "title": "AutoStack"
    },
    "alerts": {
      "lockReminder": "Recuerda bloquear las aeronaves que no deben moverse."
    }
  },
  "selectStackStrategy": {
    "common": {
      "notAvailable": "N/D",
      "noOverlap": "Sin traslape"
    },
    "strategies": {
      "normal": {
        "title": "Normal",
        "description": "Operaciones diarias con procedimientos estándar."
      },
      "tight": {
        "title": "Justo",
        "description": "Optimizado para máxima utilización."
      },
      "loose": {
        "title": "Suelto",
        "description": "Optimizado para remolque fácil, a costa de la utilización."
      },
      "custom": {
        "title": "Personal",
        "description": "Personaliza completamente tus preferencias de configuración."
      }
    },
    "spacing": {
      "horizontal": "Horizontal: {{value}}",
      "overlapMin": "Superposición mín: {{value}}"
    }
  },
  "selectTowingEquipment": {
    "labels": {
      "towingEquipment": "Equipo de remolque para stack",
      "ignore": "Ignorar"
    }
  },
  "stackResult": {
    "utilization": "Utilización",
    "inside": "Interior",
    "outside": "Exterior",
    "selectStack": "Seleccionar Stack",
    "flagPoorLayout": "Marcar diseño deficiente"
  },
  "hangarPrintLayout": {
    "aircraft": "Aeronave",
    "utilization": "Utilización",
    "estValue": "Valor est.",
    "estTowTime": "Tiempo remolque",
    "footer": {
      "automaticallyOptimizedBy": "Optimizado automáticamente por",
      "contactInfo": "Contáctenos en www.airplx.com o peter@airplx.com."
    }
  }
}
